import { useMutation } from '@tanstack/react-query';
import { Form, Space, TableProps } from 'antd';
import { CalculationSetupApis } from 'apis/CalculationSetupApis';
import { EditButtonIcon, EditIcon } from 'assets/svg';
import { ButtonAction, SelectForm, Switch } from 'components';
import InputNumberForm from 'components/Input/InputNumberForn';
import TableComponent from 'components/Table/TableComponent';
import { useUser } from 'contexts/UserProvider';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import React, { forwardRef, useImperativeHandle } from 'react';
import {
  comparisonSignOptions,
  comparisonSigns,
} from 'utils/constants/constant';
import {
  formatCurrency,
  formatDate,
  generateUUID,
  toastError,
  toastSuccess,
} from 'utils/constants/functions';
import { icons } from 'utils/constants/icons';

interface IProps extends React.PropsWithChildren<TableProps> {
  data: any;
  onSave: () => void;
  onCancel: () => void;
  onEdit: (data: any) => void;
  indexHandle: number;
  // setIndexHandle: (value: number) => void;
  isAdd: boolean;
  form: any;
  refetch: (
    page?: number,
    page_size?: number,
    isExport?: boolean,
    headerRow?: any,
  ) => void;
}
const { SaveTwoTone, CloseCircleTwoTone } = icons;
const TableRewardFrameTab = forwardRef((props: IProps, ref: any) => {
  const {
    data = {},
    loading,
    refetch,
    onSave,
    onCancel,
    indexHandle,
    isAdd,
    form,
    onEdit,
  } = props;

  const { user } = useUser();

  const {
    mutate: mutateUpdateRewardSeqmentStatus,
    isPending: isPendingUpdateRewardSeqmentStatus,
  } = useMutation({
    mutationFn: CalculationSetupApis.updateRewardSeqmentStatus,
    onSuccess: () => {
      toastSuccess('Cập nhật trạng thái khung thưởng thành công');
      refetch();
    },
    onError: () => {
      toastError('Cập nhật trạng thái khung thưởng thất bại');
    },
  });

  const columns: ColumnsTypeCustom = [
    {
      title: 'STT',
      width: 50,
      align: 'center',
      render: (_, __, index) =>
        data.pageInfo?.itemsPerPage * (data.pageInfo?.currentPage - 1) +
        index +
        1,
    },
    {
      title: 'Mã điều kiện',
      width: 130,
      dataIndex: 'rewardSetupId',
      // render: (value, record, index) => {
      //   if (indexHandle === index)
      //     return (
      //       <Form.Item name={'rewardSetupId'} className="m-0">
      //         <SelectForm placeholder="Chọn mã điều kiện" size="middle" />
      //       </Form.Item>
      //     );
      //   return value;
      // },
    },
    {
      title: 'Loại',
      width: 130,
      dataIndex: ['ttype', 'name'],
      // render: (value, record, index) => {
      //   if (indexHandle === index)
      //     return (
      //       <Form.Item name={['ttype', 'name']} className="m-0">
      //         <SelectForm placeholder="Chọn loại" size="middle" />
      //       </Form.Item>
      //     );
      //   return value;
      // },
    },
    {
      title: 'Khung thưởng',
      width: 130,
      dataIndex: 'rewardSeqment',
      // render: (value, record, index) => {
      //   if (indexHandle === index)
      //     return (
      //       <Form.Item name={'rewardSeqment'} className="m-0">
      //         <SelectForm placeholder="Chọn khung thưởng" size="middle" />
      //       </Form.Item>
      //     );
      //   return value;
      // },
    },
    {
      title: '% đạt từ (dấu so sánh)',
      width: 170,
      dataIndex: 'fromCondition',
      render: (value, record, index) => {
        if (indexHandle === index)
          return (
            <Form.Item name={'fromCondition'} className="m-0">
              <SelectForm
                options={comparisonSignOptions}
                placeholder="Chọn dấu % đạt từ"
                size="middle"
              />
            </Form.Item>
          );
        return comparisonSigns[value as keyof typeof comparisonSigns];
      },
    },
    {
      title: '% đạt từ',
      width: 130,
      dataIndex: 'fromPercent',
      align: 'right',
      render: (value, record, index) => {
        if (indexHandle === index)
          return (
            <Form.Item name={'fromPercent'} className="m-0">
              <InputNumberForm placeholder="Nhập % đạt từ" size="middle" />
            </Form.Item>
          );
        return value;
      },
    },
    {
      title: '% đạt đến (dấu so sánh)',
      width: 190,
      dataIndex: 'toCondition',
      render: (value, record, index) => {
        if (indexHandle === index)
          return (
            <Form.Item name={'toCondition'} className="m-0">
              <SelectForm
                options={comparisonSignOptions}
                placeholder="Chọn dấu % đạt đến"
                size="middle"
              />
            </Form.Item>
          );
        return comparisonSigns[value as keyof typeof comparisonSigns];
      },
    },
    {
      title: '% đạt đến',
      width: 130,
      dataIndex: 'toPercent',
      align: 'right',
      render: (value, record, index) => {
        if (indexHandle === index)
          return (
            <Form.Item name={'toPercent'} className="m-0">
              <InputNumberForm placeholder="Nhập % đạt đến" size="middle" />
            </Form.Item>
          );
        return value;
      },
    },
    {
      title: 'Đơn giá thưởng',
      width: 130,
      dataIndex: 'rewardAmount',
      align: 'right',
      render: (value, record, index) => {
        if (indexHandle === index)
          return (
            <Form.Item name={'rewardAmount'} className="m-0">
              <InputNumberForm
                placeholder="Nhập đơn giá thưởng"
                size="middle"
              />
            </Form.Item>
          );
        return value ? formatCurrency({ value }) : '-';
      },
    },
    {
      title: 'Người khai báo',
      width: 130,
      dataIndex: ['tcreateUser', 'fullName'],
    },
    {
      title: 'Ngày khai báo',
      width: 170,
      dataIndex: 'createDate',
      type: 'date',
      render: (value) => formatDate(value),
    },
    {
      title: 'Người cập nhật',
      width: 130,
      dataIndex: ['tmodifyUser', 'fullName'],
    },
    {
      title: 'Ngày cập nhật',
      width: 170,
      dataIndex: 'modifyDate',
      type: 'date',
      render: (value) => formatDate(value),
    },
    {
      fixed: 'right',
      align: 'center',
      width: 70,
      render: (__, record, index) =>
        index === indexHandle ? (
          <Space size={'middle'} className="text-lg">
            <ButtonAction tooltip="Lưu" onClick={onSave}>
              <SaveTwoTone style={{ fontSize: 20 }} />
            </ButtonAction>
            <ButtonAction tooltip="Hủy" onClick={onCancel}>
              <CloseCircleTwoTone style={{ fontSize: 20 }} />
            </ButtonAction>
          </Space>
        ) : (
          <Space size={'middle'} className="text-lg">
            <ButtonAction
              tooltip="Chỉnh sửa"
              onClick={() => onEdit(index)}
              disabled={!(user?.isAdmin || user?.isHO || user?.isNS)}
            >
              <EditButtonIcon />
            </ButtonAction>
            <Switch
              disabled={!(user?.isAdmin || user?.isHO || user?.isNS)}
              checked={record?.useYn}
              onChange={() =>
                mutateUpdateRewardSeqmentStatus({
                  id: record.id,
                  useYn: !record.useYn,
                })
              }
            />
          </Space>
        ),
    },
  ];

  useImperativeHandle(ref, () => ({
    exportExcel,
  }));

  const exportExcel = () => {
    refetch(1, data.pageInfo?.totalItems, true, columns);
  };
  return (
    <Form form={form}>
      <TableComponent
        scroll={{ x: 'max-content' }}
        columns={columns}
        // dataSource={[{}]}
        dataSource={data.items}
        rowKey={(record: any) => record?.id || generateUUID()}
        loading={loading || isPendingUpdateRewardSeqmentStatus}
        pagination={{
          disabled: isAdd || indexHandle !== -1,
          current: data.pageInfo?.currentPage,
          pageSize: data.pageInfo?.itemsPerPage,
          total: data.pageInfo?.totalItems,
          onChange: (page, page_size) => refetch(page, page_size),
        }}
      />
    </Form>
  );
});

export default TableRewardFrameTab;
